/**
 * Owner-admin API client for N6-N9 (player CSV, AI dashboards, feedback).
 * All under /api/admin/v2/, IsSuperuser-gated server-side.
 */
import api from "./axios";

// ── N6 — Player CSV bulk upload ───────────────────────────────────────

export const bulkUploadPlayers = (csvFile, dryRun = true) => {
  const fd = new FormData();
  fd.append("csv_file", csvFile);
  fd.append("dry_run", dryRun ? "true" : "false");
  return api.post("/api/admin/v2/players/bulk-upload/", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// ── N7 — AI Learning dashboard ────────────────────────────────────────

export const getAILearningDashboard = () =>
  api.get("/api/admin/v2/ai-learning/dashboard/");

// ── N8 — AI Usage analytics ───────────────────────────────────────────

export const getAIUsageDashboard = ({ days } = {}) =>
  api.get("/api/admin/v2/ai-learning/usage/", {
    params: days ? { days } : undefined,
  });

// ── N9 — Feedback admin ───────────────────────────────────────────────

export const listFeedbackThreads = (params = {}) =>
  api.get("/api/admin/v2/feedback/threads/", { params });

export const getFeedbackThread = (id) =>
  api.get(`/api/admin/v2/feedback/threads/${id}/`);

export const replyFeedbackThread = (id, { message, status }) =>
  api.post(`/api/admin/v2/feedback/threads/${id}/reply/`, { message, status });

// Mark a feedback thread completed without writing a reply.
// Idempotent — re-calling on an already-closed thread is a no-op.
export const markFeedbackResolved = (id) =>
  api.post(`/api/admin/v2/feedback/threads/${id}/mark-resolved/`);

// ── Zen Credits grants (Customer > Credits) ───────────────────────────

export const searchCreditUsers = (q) =>
  api.get("/api/admin/v2/credits/users/", { params: { q } });

export const listCreditGrants = (params = {}) =>
  api.get("/api/admin/v2/credits/", { params });

// request_id makes a retried submit a no-op instead of a second grant.
export const grantCredits = ({ userId, credits, notes, requestId }) =>
  api.post("/api/admin/v2/credits/", {
    user_id: userId, credits, notes, request_id: requestId,
  });
